/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_A3tInputs */

const en_mk_sol_startup_a3t = /** @type {(inputs: Mk_Sol_Startup_A3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimo — Data & Analytics`)
};

const id_mk_sol_startup_a3t = /** @type {(inputs: Mk_Sol_Startup_A3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimo — Data & Analitik`)
};

/**
* | output |
* | --- |
* | "Bimo — Data & Analytics" |
*
* @param {Mk_Sol_Startup_A3tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_a3t = /** @type {((inputs?: Mk_Sol_Startup_A3tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_A3tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_a3t(inputs)
	return en_mk_sol_startup_a3t(inputs)
});